<app-auth-page-layout>
  <div class="flex flex-col items-center justify-center flex-1 px-4">

    <div class="w-full max-w-md bg-white shadow-xl rounded-2xl p-8 text-center">

      <!-- Loading -->
      <ng-container *ngIf="status === 'loading'">
        <div class="flex flex-col items-center gap-4">
          <div class="w-10 h-10 border-4 border-brand-500 border-t-transparent rounded-full animate-spin"></div>
          <h2 class="text-xl font-semibold text-gray-700">
            Verifying your email...
          </h2>
          <p class="text-gray-500 text-sm">
            Please wait while we confirm your email address.
          </p>
        </div>
      </ng-container>

      <!-- Success -->
      <ng-container *ngIf="status === 'success'">
        <div class="flex flex-col items-center gap-4">
          <div class="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
            <svg class="w-8 h-8 text-green-600" fill="none" stroke="currentColor"
              stroke-width="3" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M5 13l4 4L19 7" />
            </svg>
          </div>

          <h2 class="text-2xl font-bold text-gray-800">
            Email Verified 🎉
          </h2>

          <p class="text-gray-600 text-sm">
            {{ message }}
          </p>

          <a routerLink="/login"
            class="mt-4 inline-block bg-brand-500 text-white px-6 py-2 rounded-xl hover:bg-brand-600 transition">
            Go to Login
          </a>
        </div>
      </ng-container>

      <!-- Error -->
      <ng-container *ngIf="status === 'error'">
        <div class="flex flex-col items-center gap-4">
          <div class="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
            <svg class="w-8 h-8 text-red-600" fill="none" stroke="currentColor"
              stroke-width="3" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>

          <h2 class="text-2xl font-bold text-gray-800">
            Verification Failed
          </h2>

          <p class="text-gray-600 text-sm">
            {{ message }}
          </p>

          <div class="w-full mt-2 text-left">
            @if (!resendSent) {
            <p class="text-sm text-gray-600 mb-2">
              Link expired? Enter your email and we'll send you a new one.
            </p>
            <form (ngSubmit)="resendVerification()" class="flex flex-col gap-2 sm:flex-row">
              <input type="email" name="resendEmail" [(ngModel)]="resendEmail" required
                placeholder="you@example.com" autocomplete="email"
                class="h-11 flex-1 rounded-lg border border-gray-300 px-4 text-sm text-gray-800 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10" />
              <button type="submit" [disabled]="isResending || !resendEmail.trim()"
                class="h-11 rounded-xl border border-brand-500 px-4 text-sm font-medium text-brand-500 hover:bg-brand-50 disabled:opacity-60">
                {{ isResending ? 'Sending…' : 'Resend link' }}
              </button>
            </form>
            } @else {
            <p class="text-sm text-green-700 text-center">
              Check your inbox — if your account still needs verifying, a new link has been sent. It expires in 24 hours.
            </p>
            }
          </div>

          <a routerLink="/login"
            class="mt-4 inline-block bg-brand-500 text-white px-6 py-2 rounded-xl hover:bg-brand-600 transition">
            Go to Login
          </a>
        </div>
      </ng-container>

    </div>

  </div>
</app-auth-page-layout>
